import * as React from 'react';

import Logo from 'shared/newComponents/Logo';

import Right from '../../Right';

import './MobileHeader.modules.scss';

const MobileHeader: React.FC = () => {
  return (
    <div styleName="mobile-menu">
      <Logo full={false} />
      <Right />
    </div>
  );
};

export default React.memo(MobileHeader);
